// extracted by mini-css-extract-plugin
export var actionText = "_q8-4";
export var container = "_q8-0";
export var leftSection = "_q8-1";
export var rightSection = "_q8-2";
export var settingsButton = "_q8-6";
export var settingsIcon = "_q8-7";
export var shortcut = "_q8-5";
export var shortcutGroup = "_q8-3";